// import log from 'salvo-lite/log'

// class Parallax {
//   constructor (theme, elem) {
//     this._name = this.constructor.name
//     this._elems = {
//       'container': elem.querySelector('[data-parallax-container], .js-component__parallax-container'),
//       'moving': elem.querySelectorAll('[data-parallax-move], .js-component__parallax-move'),
//       'aboveStart': document.querySelectorAll('[data-parallax-above], .js-component__parallax-above'),
//       'belowStart': document.querySelectorAll('[data-parallax-below], .js-component__parallax-below')
//     }
//     this._attributes = {
//       'currPageY': window.pageYOffset,
//       'oldPageY': window.pageYOffset,
//       'currSpacing': 0,
//       'currElemIndex': 0,
//       'set': false
//     }
//   }

//   onInit () {
//     this._attachDefaultEvents()
//     log.debug(this._name, 'Initiated', this)
//   }

//   _startParallax () {
//     this._attributes.startSpace = window.getComputedStyle(this._elems.container, null).paddingTop
//     for (let elem of this._elems.aboveStart) {
//       this._attributes.currSpacing += elem.getBoundingClientRect().height
//     }
//     this._elems.moving[this._attributes.currElemIndex].classList.add('parallax-on')
//     this._manipulateContainer()
//     this._attributes.currElemIndex++
//   }

//   _stopParallax () {
//     this._attributes.currSpacing = 0
//     this._elems.moving[0].classList.remove('parallax-on')
//     this._elems.container.style.paddingTop = this._attributes.startSpace
//   }

//   _manipulateContainer () {
//     this._attributes.currSpacing += this._elems.moving[this._attributes.currElemIndex].getBoundingClientRect().height
//     this._elems.container.classList.remove('anim-padding')
//     this._elems.container.style.paddingTop = `${this._attributes.currSpacing}px`
//   }

//   _belowStartSum () {
//     let retSum = 0
//     for (let elem of this._elems.belowStart) {
//       let elemDim = elem.getBoundingClientRect()
//       retSum += elemDim.height
//     }
//     return retSum
//   }

//   _parallaxDown () {
//     if (this._attributes.currElemIndex === this._elems.moving.length) return false
//     let elemDim = this._elems.moving[this._attributes.currElemIndex].getBoundingClientRect()
//     let belowStart = this._belowStartSum()
//     if (elemDim.top > belowStart) return false
//     this._elems.moving[this._attributes.currElemIndex].classList.add('parallax-on')
//     this._manipulateContainer()
//     this._attributes.currElemIndex++
//   }

//   _parallaxUp () {
//     if (this._attributes.currElemIndex === 0) return false
//     let elemDim = this._elems.moving[this._attributes.currElemIndex - 1].getBoundingClientRect()
//     let nextElemDim = this._elems.moving[this._attributes.currElemIndex - 1].nextSibling.getBoundingClientRect()
//     if (nextElemDim.top < elemDim.bottom) return false
//     this._elems.moving[this._attributes.currElemIndex - 1].classList.remove('parallax-on')
//     this._attributes.currSpacing -= elemDim.height
//     this._elems.container.style.paddingTop = `${this._attributes.currSpacing}px`
//     this._attributes.currElemIndex--
//   }

//   _attachDefaultEvents () {
//     document.body.addEventListener('sticky-header', e => {
//       if (this._attributes.set && !e.hit) {
//         this._stopParallax()
//         this._attributes.set = false
//         return false
//       } else if (this._attributes.set) {
//         return false
//       }
//       this._attributes.set = true
//       this._startParallax()
//     })

//     window.addEventListener('scroll', e => {
//       if (!this._attributes.set) return false
//       this._attributes.currPageY = window.pageYOffset
//       let directionFunc = '_parallax'
//       directionFunc += this._attributes.currPageY > this._attributes.oldPageY ? 'Down' : 'Up'
//       this._attributes.oldPageY = this._attributes.currPageY
//       this[directionFunc]()
//     })
//   }
// }

// export default Parallax

import log from 'salvo-lite/log'
import Rellax from 'rellax'

class Parallax {
    constructor (theme, elem) {
        this.elem = elem
        this.options = Object.assign({
            speed: -10,
            center: false,
            round: false,
            vertical: true,
            horizontal: false
        }, JSON.parse(this.elem.dataset.parallax ? this.elem.dataset.parallax : '{}'))
        if (window.innerWidth <= 768) {
            this.options = Object.assign(this.options, this.options.mobile)
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating', this)
        Rellax(this.elem, this.options)
        log.debug(this.constructor.name, 'Initiated', this)
    }
}

export default Parallax



// WEBPACK FOOTER //
// ./src/scripts/components/Parallax.js